// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3lgrU","notes":"Notes_notes__2gybJ"};